// extracted by mini-css-extract-plugin
export default {"h1":"Heading_h1__fEhpE h1","h2":"Heading_h2__QUCCG h2","h3":"Heading_h3__FWxAH h3","h4":"Heading_h4__xj6-A h4","h5":"Heading_h5__dtQeZ h5","h6":"Heading_h6__+DScD h6"};